import { isEmpty } from '@ember/utils';
import { DataActionConditionType } from 'cio/utils/campaigns/data-action';

export function shouldShowRemoveAttribute(row: { type: DataActionConditionType; value: string }) {
  return row.type === DataActionConditionType.RemoveAttribute || isEmpty(row.value);
}
